import { useSelector } from "react-redux";

export function useAdvisor() {
  return useSelector((state) => state.advisor);
}
